import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgFingerTie = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.92693 21.2386L4.64286 16.9538C4.24586 16.5436 4.02596 15.9939 4.03059 15.4231C4.03522 14.8524 4.26402 14.3063 4.66763 13.9027C5.07125 13.4991 5.61733 13.2703 6.18811 13.2656C6.75889 13.261 7.30862 13.4809 7.71873 13.8779L8.92693 15.0869V5.24414C8.92693 4.59152 9.18618 3.96564 9.64765 3.50417C10.1091 3.0427 10.735 2.78345 11.3876 2.78345C12.0402 2.78345 12.6661 3.0427 13.1276 3.50417C13.5891 3.96564 13.8483 4.59152 13.8483 5.24414V11.3959H15.0787C16.3839 11.3959 17.6357 11.9144 18.5586 12.8373C19.4816 13.7603 20.0001 15.012 20.0001 16.3173V21.2386"
          stroke="currentColor"
          strokeWidth={1.02529}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8484 10.1655H8.927"
          stroke="currentColor"
          strokeWidth={1.02529}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8484 6.47443H8.927"
          stroke="currentColor"
          strokeWidth={1.02529}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.23584 6.47443L8.92688 8.31995L5.23584 10.1655"
          stroke="currentColor"
          strokeWidth={1.02529}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgFingerTie.displayName = 'SvgFingerTie';
export default SvgFingerTie;
